import React from 'react';
import Rail from '@dazn/lp-web/src/components/Rail/Rail';
import {ISubscriptionsRail} from '@dazn/lp-web/src/types';
import {useLandingPagesContext} from '@dazn/lp-web/src/contexts/LandingPageContext';

interface ISubscriptionsRailProps {
    data: ISubscriptionsRail;
    key: number;
    disableAnimation: boolean;
}

const SubscriptionsRail: React.FC<ISubscriptionsRailProps> = ({
    data,
    disableAnimation
}) => {
    const {offers} = useLandingPagesContext();
    const availableSubscriptions = offers?.Entitlements?.map(
        (entitlement) => entitlement.setId
    );
    const rail = {
        ...data,
        tiles: data.tiles.filter((tile) => {
            const entitlementSetId = tile?.button?.entitlementSetId?.trim();

            if (entitlementSetId) {
                return availableSubscriptions?.includes(entitlementSetId);
            }

            return true;
        })
    };

    return (
        <Rail
            key={data.componentType}
            rail={rail}
            disableAnimation={disableAnimation}
        />
    );
};

export default SubscriptionsRail;
